import { Type, type, Dom } from "main.core";
var bxTmp = window.VS;

window.VS = function (node, container) {
  if (Type.isDomNode(node)) {
    return node;
  }
  if (type.isNotEmptyString(node)) {
    if (!container) container = document;
    if (
      node.startsWith(".") ||
      node.startsWith("#") ||
      typeof container.getElementById === "undefined"
    ) {
      return container.querySelectorAll(node);
    }
    return container.getElementById(node);
  }
  if (Type.isArrayLike(node)) {
    return node[0];
  }
  if (Type.isFunction(node)) {
    return window.BX.ready(node);
  }
  return null;
};

if (bxTmp) {
  Object.keys(bxTmp).forEach((key) => {
    window.VS[key] = bxTmp[key];
  });
}

// запрет резать теги в редакторе
BX.addCustomEvent("OnEditorInitedBefore", function (toolbar) {
  var _this = this;
  //debugger;
  BX.addCustomEvent(
    this,
    "OnGetParseRules",
    BX.proxy(function () {
      _this.rules.tags.span = {};
      _this.rules.tags.svg = {};
      _this.rules.tags.use = {};
      _this.rules.tags.path = {};
      _this.rules.tags.g = {};
      _this.rules.tags.rect = {};
    }, this)
  );
});
exports = window.VS;
